import { fg } from '@atlassian/jira-feature-gating';
import type { Features } from '../features/types.tsx';

export const useViewsFeature = ({ features }: { features: Features | null }) => {
	if (!fg('jsm_views_of_work_phase_1')) {
		return {
			isEnabled: false,
			url: '',
		};
	}

	const isBoardEnabled = !!features?.jsmBoard?.enabled;
	const boardUrl = features?.jsmBoard?.url ?? '';
	const isCalendarEnabled = !!features?.jsmCalendar?.enabled;
	const calendarUrl = features?.jsmCalendar?.url ?? '';
	const isEnabled = (isBoardEnabled && !!boardUrl) || (isCalendarEnabled && !!calendarUrl);

	if (!isEnabled) {
		return {
			isEnabled: false,
			url: '',
		};
	}

	return {
		isEnabled: true,
		url: isBoardEnabled ? boardUrl : calendarUrl,
	};
};
